// extracted by mini-css-extract-plugin
export default {"logoWrapper":"Root_logoWrapper__PRnon","titleWrapper":"Root_titleWrapper__qe6Uv","rootWrapper":"Root_rootWrapper__BN4q7","buttonWrapper":"Root_buttonWrapper__ndwnZ"};